import React from 'react';
import { Accordion, Card, Button, Table, Pagination } from 'react-bootstrap';
import { translate } from "react-i18next";
import { getURL } from '../../backend/Backend';
import {GREEN_LIGHT, RED_LIGHT} from "../../backend/Colors"

class DateChoiceResponseInfo extends React.Component {
  constructor(props) {
    super(props);
    this.loadDateChoiceResponses = this.loadDateChoiceResponses.bind(this);
    this.pageChanged = this.pageChanged.bind(this);

    this.state = {
      event: {
        "allDateChoiceResponses": [],
        activePage: 1,
        totalPages: 0
      }
    }
  }

  async loadDateChoiceResponses() {
    let page = this.state.event.activePage
    const response = await fetch(getURL(`dateChoiceResponses/loadPageResponses/${this.props.id}/${this.props.type}/${page - 1}`));

    const json = await response.json();
    let oldEvent = this.state.event;
    let newEvent = {
      ...oldEvent,
      allDateChoiceResponses: json.content,
      totalPages: json.totalPages,
      activePage: page
    }
    this.setState({ event: newEvent });
  }


  async pageChanged(e) {
    this.loadItems(e.target.text);
  }

  async loadItems(page) {
    if (!page) {
      return;
    }
    if ("<" === page) {
      page = --this.state.event.activePage;
    }
    if (">" === page) {
      page = ++this.state.event.activePage;
    }
    const response = await fetch(getURL(`dateChoiceResponses/loadPageResponses/${this.props.id}/${this.props.type}/${page - 1}`));
    const json = await response.json();
    let oldEvent = this.state.event;
    let newEvent = {
      ...oldEvent,
      allDateChoiceResponses: json.content,
      totalPages: json.totalPages,
      activePage: page
    }
    this.setState({ event: newEvent });
  }


  render() {
    if(this.props.max === 0){
      return "";
    }
    let textCss = this.props.type === 'YES' ? GREEN_LIGHT:RED_LIGHT //"text-success":"text-danger" 
    let label = this.props.type === 'YES' ? "accepted":"declined";
    const { t } = this.props;
    return (
      <div className=" justify-content-between d-relative  ">
        <Accordion defaultActiveKey="1">
          <Card border="light" bg="light" >
            <Accordion.Toggle as={Button} variant="link" eventKey="0" onClick={this.loadDateChoiceResponses} className="text-primary text-left">
              <i style={{"color":textCss}}  className={ " fa fa-users s16 mr-2"}></i>{this.props.max +" "+ t(label)}
              </Accordion.Toggle>
            <Accordion.Collapse eventKey="0">
              <Card.Body >
                <Table responsive size="sm">
                  <tbody>
                    {this.state.event.allDateChoiceResponses.map((u,i) =>
                      <tr key={i}>
                        <td>
                          {u.responseType === 'NO' ?
                            (<i style={{"color":RED_LIGHT}} className=" fa fa-times s16 mr-3 "></i>)
                            :
                            (u.responseType === 'YES') ?
                              (<i style={{"color":GREEN_LIGHT}} className=" fa fa-check s16 mr-2"></i>)
                              :
                              (<i style={{"color":GREEN_LIGHT}} className=" fa fa-question s16 mr-2"></i>)
                          }
                          {u.invitedUserName}</td>
                      </tr>
                    )}
                  </tbody>
                </Table>
                <Pagination onClick={this.pageChanged}>
                  {this.state.event.activePage > 1 ?
                    <Pagination.Item>{'<'}</Pagination.Item>
                    : ""
                  }

                  {[...Array(this.state.event.totalPages).keys()].map(i => {
                    return <Pagination.Item active={(i + 1) === this.state.event.activePage} key={i}>{i + 1}</Pagination.Item>
                  })
                  }
                  {this.state.event.activePage < this.state.event.totalPages ?
                    <Pagination.Item>{'>'}</Pagination.Item>
                    : ""
                  }

                </Pagination>
              </Card.Body>
            </Accordion.Collapse>
          </Card>

        </Accordion>
      </div>
    );
  }

}

export default translate("translations")(DateChoiceResponseInfo);